import type { Theme } from '@trinity/chat-components/types/theme';
import { createNamedContext } from '@trinity/chat-components/utils';

export type ResponseTheme = {
  app: {
    prompt: {
      documents: string;
    } | null;
    title: string | null;
  };
  color: {
    bubble: string;
    primary: string;
    prompt: string;
  };
  enabled: boolean;
  logo: {
    horizontal: string;
    square: string;
  };
};

export type AppThemingPalette = {
  enabled: boolean;
  blue: Theme.WhiteLabelPalette['blue'] | null;
  green: Theme.WhiteLabelPalette['green'] | null;
  primary: Theme.WhiteLabelPalette['primary'] | null;
  prompt: Theme.WhiteLabelPalette['prompt'] | null;
  shade: Theme.WhiteLabelPalette['shade'] | null;
};

export type AppThemingContextValue = {
  enabled: boolean;
  query: {
    data: ResponseTheme;
    isLoading: boolean;
    isPlaceholderData: boolean;
    isFetching: boolean;
    isFetchedAfterMount: boolean;
  };
  palette: AppThemingPalette;
  theme: ResponseTheme;
};
export type AppThemingFetchContextValue = () => Promise<ResponseTheme>;

// Default/placeholder context value, components should always be wrapped in AppThemingContainer
const defaultAppThemingValue: AppThemingContextValue | undefined = undefined;

export const AppThemingContext = createNamedContext<AppThemingContextValue | undefined>(
  defaultAppThemingValue,
  'AppTheming.Context'
);
export const AppThemingFetchContext = createNamedContext<AppThemingFetchContextValue | undefined>(
  async () => ({
    app: {
      title: null,
      prompt: null,
    },
    color: {
      bubble: null,
      primary: null,
      prompt: null,
    },
    enabled: null,
    logo: {
      horizontal: null,
      square: null,
    },
  }),
  'AppTheming.FetchContext'
);
export const AppThemingHashContext = createNamedContext<string | undefined>(
  undefined,
  'AppTheming.HashContext'
);
